import { BaseModel } from './base-model';

export class MeterRecordDataModel implements BaseModel {
  public data_info?: {
    name: string;
    uniq_id: string;
    units: string;
    record_count: number;
    record_count_units: string;
  }[];
  public data?: {
    dt: string;
    value: number;
    value_units: string;
    value_min: number;
    value_min_units: string;
    value_max: number;
    value_max_units: string;
    value_dif: number;
    value_dif_units: string;
  }[];

  init() {}
}
